import React from "react";
import { Route } from "react-router-dom";
import ListActorsContainer from "./list-container";
import AddActor from "./add";
import EditActor from "./edit";
import Overview from "./overview/container";
import Copy from "./copy/container";
import { PrivateRoute } from "../../shared/private-route";

const ActorRoutes = () => {
  return (
    <>
      <PrivateRoute
        path="/films/:filmId/background-actors"
        component={ListActorsContainer}
      />
      <PrivateRoute
        exact
        path="/films/:filmId/background-actors/overview"
        component={Overview}
      />
      <PrivateRoute
        exact
        path="/films/:filmId/background-actors/copy"
        component={Copy}
      />
      <PrivateRoute
        exact
        path="/films/:filmId/background-actors/add"
        component={AddActor}
      />
      <PrivateRoute
        exact
        path="/films/:filmId/background-actors/add-from-mandy"
        component={(props) => <AddActor source="mandy" {...props} />}
      />
      <PrivateRoute
        exact
        path="/films/:filmId/background-actors/add-from-starnow"
        component={(props) => <AddActor source="starnow" {...props} />}
      />
      <PrivateRoute
        exact
        path="/films/:filmId/background-actors/:actorId"
        component={EditActor}
      />
      <PrivateRoute
        exact
        path="/films/:filmId/background-actors/:actorId/edit"
        component={EditActor}
      />
    </>
  );
};

export default ActorRoutes;
